import { MAX_MB, MB } from '../constants/docUploadConstant'
import { getLanguage } from '../utils/loadConfig'

const MESSAGES_EN = {
    accept: 'accept',
    accepted: 'Accepted',
    of: 'of',
    additional_fees: 'plus additional fees and discount.',
    axzprice_part1: '*AXZ plan pricing of',
    axzprice_part2: 'plus additional fees and discounts.',
    amount_paid_at_lease_signing: 'Amount Paid at Lease Signing',
    amount_paid_in_cash: 'Amount Paid in Cash',
    amounts_due_at_lease_signing: 'Amounts Due at Lease Signing',
    amount_due_at_signing: 'Amount Due at Signing',
    amounts_due_at_signing: 'Amounts Due at Signing',
    back_to_dashboard: 'Back to Dashboard',
    vehicle_purchase_price: 'Vehicle Purchase Price',
    gross_captitalizes_cost: 'Gross Capitalized Cost Breakdown',
    banner_dec_price_message: 'Your price has decreased since placing your order.',
    banner_fin_message:
        'Your payment method has changed since you placed your order. This may impact the pricing seen here.',
    banner_inc_price_message: 'Your price has increased since placing your order.',
    banner_type_balance_issue: 'no banner balance issue',
    banner_type_finance_type_changed: 'Banner finance Type Changed , no CTA',
    banner_type_no_banner: 'No Banner',
    banner_type_price_decrease: 'Banner with cta from price decrease',
    banner_type_price_increase: 'Banner with cta from price increase',
    banner_type_vin_changed: 'Banner VIN Changed , no CTA',
    banner_vin_message:
        'Your selected vehicle has changed since you placed your order. This may impact the pricing seen here.',
    cash_down_payment: 'Cash Down Payment',
    cash_purchase_details: 'Cash Purchase Details',
    capitalized_cost_breakdown: 'Capitalized Cost Breakdown',
    capitalized_cost_reduction: 'Capitalized Cost Reduction',
    check_with_dealer: 'Check with your dealer for more information on your financing.',
    completed: 'completed',
    credit_card_down_payment: 'Credit Card Down Payment',
    details: 'Details',
    decreases: 'Decreases',
    decreases_case: 'Decreases to Amount Due At Dealer',
    decreases_lease: 'Decreases to Adjusted Capitalized Cost',
    decreases_finance: 'Decreases to Amount Financed',
    decreases_popover_description: 'Pricing changes that decrease your total price.',
    disclosures: 'Disclosures',
    discloser: 'Discloser',
    does_everything_look_correct: 'Does everything look correct?',
    first_monthly_payment: 'First Monthly Payment',
    finance_details: 'Finance Details',
    flexbuy_details: 'Flexbuy Details',
    ford_credit_financing_details: 'Ford Credit Financing Details',
    how_amounts_due_will_be_paid: 'How Amounts Due Will Be Paid',
    includes_axz_plan_pricing: 'Includes AXZ Plan Pricing',
    increases: 'Increases',
    increases_case: 'Increases to Amount Due At Dealer',
    increases_lease: 'Increases to Adjusted Capitalized Cost',
    increases_finance: 'Increases to Amount Financed',
    increases_popover_description: 'Pricing changes that increase your total price.',
    lease: 'Lease',
    lease_payment: 'Lease Payment',
    leasing_details: 'Leasing Details',
    mi: 'MI',
    mileage: 'Mileage',
    mo: 'mo',
    mo_caps: 'MO',
    mos: 'mos',
    monthly_localfee: 'Local Fee',
    monthly_payment: 'Monthly Payment',
    net_trade_in_amount: 'Net Trade-In Amount',
    no_notify_dealer: 'No, Notify Dealer',
    no_notify_my_dealer: 'No, Notify My Dealer',
    other_upfront_costs: 'Other Upfront Costs',
    ordered_from: 'Ordered From',
    pds: 'pds',
    pending: 'pending',
    pre_delivery_summary: 'Pre-Delivery Summary',
    price_changes: 'Price Changes',
    old_price_change_description:
        'Your dealer wants you to be aware of {{total}} price change that will impact your total. If you have questions or concerns, reach out to your dealer.',
    old_price_changes_description:
        'Your dealer wants you to be aware of {{total}} price changes that will impact your total. If you have questions or concerns, reach out to your dealer.',
    price_change_description:
        'Your dealer wants you to be aware of {{total}} change that will impact your total to ensure upfront pricing and transparency. If you have questions or concerns, reach out to your dealer, {{dealerName}} at {{dealerPhoneNumber}}.',
    price_changes_description:
        'Your dealer wants you to be aware of {{total}} changes that will impact your total to ensure upfront pricing and transparency. If you have questions or concerns, reach out to your dealer, {{dealerName}} at {{dealerPhoneNumber}}.',
    prior_credit_lease_owed_on_trade: 'Prior Credit or Lease Balance',
    print_pds_confirmation: 'Print or download the accepted document for your records.',
    print: 'Print',
    download: 'Download',
    rejected: 'rejected',
    save_print: 'Save or print your document',
    sub_heading:
        'Please review the pricing estimate your dealer has provided. Your dealer can assist with any questions you may have.',
    surface_protection: 'Surface Protection',
    taxes_and_fees: 'Taxes and Fees',
    term: 'Term',
    thank_you: 'Thank you {{name}} !',
    total_accessories: 'Total Accessories',
    total_capitalized_cost_reductions: 'Total Capitalized Cost Reductions',
    total_credit_card_payment: 'Total Credit Card Payment',
    total_change: 'Total Change',
    total_net_change: 'Total Net Change',
    total_change_popover_description:
        'The difference between your estimated order price and your current price provided by your dealer.',
    total_decreases: 'Total Decreases',
    total_down_payment: 'Total Down Payment',
    total_increases: 'Total Increases',
    total_protection_plans: 'Total Protection Plans',
    trade_in: 'Net Trade-In',
    vehicle_pricing_detail: 'Vehicle Pricing Detail',
    vehicle_purchase_details: 'Vehicle Purchase Details',
    vehicle_ordered_from: 'Vehicle ordered from',
    view_changes: 'View changes',
    view_disclosures: 'View Disclosures',
    vin: 'VIN {{vin}}',
    yes_move_forward: 'Yes, Move Forward',
    yes: 'Yes',
    yr: 'yr',
    accepted_pds: 'You have accepted the Pre-Delivery Summary',
    your_information: 'your information',
    dealer_selling_price: 'Dealer Selling Price',
    Processing: 'Processing',
    no_referesh_message: 'Please do not go back or refresh.',
    accepted_file_types: '.jpeg, .jpg, .png, .pdf',
    accept_only_images: '.jpeg, .jpg, .png',
    sorry: 'Sorry!',
    error_heading: 'We’re Experiencing Issues with our System',
    error_message: 'We are unable to process your request at this time. Please try again later.',
    delete_document_modal_title: 'Delete Document?',
    delete_document_modal_content: 'Are you sure you want to delete this document? You may need to replace it.',
    no_go_back: 'No, Go Back',
    yes_delete: 'Yes, Delete',
    mb: 'MB',
    title: 'Please Upload Dealer Requested Documents',
    requested_by: 'Requested by:',
    no_document_message: 'There are no documents requested at this time.',
    sub_heading_one:
        'By uploading, you represent all information is current and accurate and you have the right to provide it.',
    sub_heading_two: "This information is subject to your dealer's privacy policy.",
    preparing_document: 'Preparing Document',
    applicant: 'Applicant',
    coapplicant: 'Co-Applicant',
    cobuyer: 'cobuyer',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    upload: 'Upload',
    front: 'Front',
    back: 'Back',
    replace: 'Replace',
    undo: 'Undo',
    crop: 'Crop',
    rotate: 'Rotate',
    done: 'Done',
    documents: 'documents',
    error_toaster_title: 'Upload Error',
    unsupported_file_toaster_content: 'Unsupported file type. You can only upload .jpeg, .jpg, .png or .pdf.',
    image_supported_toaster_content: 'Unsupported file type. You can only upload .jpeg, .jpg or .png.',
    file_size_error: 'upload doc file too large',
    unsupported_file_type_error: 'unsupported file type',
    harmful_javascript_error_code: 'JavaScript injected file',
    harmful_virus_error_code: 'Virus infected file',
    harmful_javascript_error: 'potentially harmful file javascript',
    harmful_virus_error: 'potentially harmful file virus scan',
    harmful_toaster_title: 'Potentially Harmful File',
    harmful_toaster_content: 'The file you are attempting to upload may be harmful. Please upload a different file.',
    accepted_files: 'Accepted Files',
    back_to_doc: 'Back to Document Upload',
    document_upload: 'Document Upload',
    upload_driver_license: 'Upload Driver’s License',
    documents_requested_by: 'Documents Requested By',
    max_file_size_and_types:
        'Max file size: 5 MB | Max total upload size: 10 MB | Accepted file types: .jpeg, .jpg, .png, .pdf',
    no_doc: 'There Are No Requested Documents At This Time',
    no_doc_sub: 'You will be notified by email when your dealer requests a document',
    edit_image: 'Edit Image',
    edit_or_replace: 'Edit or replace image and click done with you have finished editing.',
    requested: 'Requested',
    COMPLETED_DESC: 'Uploaded',
    INPROGRESS_DESC: 'Uploading',
    ERROR_DESC: 'Error uploading document',
    FILESIZEERROR_DESC: `File size exceeds size limit of ${MAX_MB} ${MB}`,
    UPLOADED_DESC: 'Upload successful'
}

const MESSAGES_FR = {
    accept: 'accepter',
    accepted: 'Accepté',
    of: 'de<',
    additional_fees: 'plus les frais et réduction supplémentaires.',
    axzprice_part1: '*Prix du plan AXZ de',
    axzprice_part2: 'plus les frais et réductions supplémentaires.',
    amount_paid_at_lease_signing: 'Montant dû à la signature du bail',
    amount_paid_in_cash: 'Montant payé en comptant',
    amounts_due_at_lease_signing: 'Montants dus à la signature du bail',
    amount_due_at_signing: 'Montant dû à la signature',
    amounts_due_at_signing: 'Montants dus à la signature',
    back_to_dashboard: 'Retour au tableau de bord',
    vehicle_purchase_price: 'Prix d’achat du véhicule',
    gross_captitalizes_cost: 'Décomposition des coûts capitalisés bruts',
    banner_dec_price_message: 'Votre prix a diminué depuis que vous avez passé votre commande.',
    banner_fin_message:
        'Votre mode de paiement a changé depuis que vous avez passé votre commande. Cela peut avoir un impact sur les prix affichés ici.',
    banner_inc_price_message: 'Votre prix a augmenté depuis que vous avez passé votre commande.',
    banner_type_balance_issue: 'aucun problème de solde de bannière',
    banner_type_finance_type_changed: 'Type de financement de la bannière modifié, pas d’appel à l’action ',
    banner_type_no_banner: 'Aucune bannière',
    banner_type_price_decrease: 'Bannière avec cta de baisse de prix',
    banner_type_price_increase: "Bannière avec appel à l’action provenant de l'augmentation de prix",
    banner_type_vin_changed: 'NIV de la bannière modifié , pas d’appel à l’action ',
    banner_vin_message:
        'Le véhicule que vous avez sélectionné a changé depuis que vous avez passé votre commande. Cela peut avoir un impact sur les prix affichés ici.',
    cash_down_payment: 'Acompte en espèces',
    cash_purchase_details: 'Détails de l’achat en espèces',
    capitalized_cost_breakdown: 'Décomposition du coût capitalisé',
    capitalized_cost_reduction: 'Réduction du coût capitalisé',
    check_with_dealer: 'Consultez votre concessionnaire pour plus d’informations sur votre financement.',
    completed: 'terminé',
    credit_card_down_payment: 'Acompte par carte de crédit',
    details: 'Détails',
    decreases: 'Diminution',
    decreases_case: 'Réductions du montant dû au concessionnaire',
    decreases_lease: 'Réductions du coût capitalisé ajusté',
    decreases_finance: 'Diminution du montant financé',
    decreases_popover_description: 'Modifications de prix qui diminuent votre prix total.',
    disclosures: 'Divulgations',
    discloser: 'Divulgateur',
    does_everything_look_correct: 'Tout semble-t-il correct?',
    first_monthly_payment: 'Premier paiement mensuel',
    finance_details: 'Détails financiers',
    flexbuy_details: 'Détails de Flexbuy',
    ford_credit_financing_details: 'Détails du financement du Crédit Ford',
    how_amounts_due_will_be_paid: 'Méthode par laquelle les montants dus seront payés',
    includes_axz_plan_pricing: 'Inclut le prix du plan AXZ',
    increases: 'augmente',
    increases_case: 'Augmentation du montant dû au concessionnaire',
    increases_lease: 'Augmentation du coût capitalisé ajusté',
    increases_finance: 'Augmentation du montant financé',
    increases_popover_description: 'Modifications de prix qui augmentent votre prix total.',
    lease: 'Location',
    lease_payment: 'Paiement de location',
    leasing_details: 'Détails de la location',
    mi: 'MI',
    mileage: 'Mileage',
    mo: 'mois',
    mo_caps: 'MO',
    mos: 'mos',
    monthly_localfee: 'Frais locaux',
    monthly_payment: 'Paiement_mensuel',
    net_trade_in_amount: 'Montant net de l’échange',
    no_notify_dealer: 'Non, informer le concessionnaire',
    no_notify_my_dealer: 'Non, informer mon concessionnaire',
    other_upfront_costs: 'Autres coûts initiaux',
    ordered_from: 'Commandé à partir de',
    pds: 'pds',
    pending: 'en attente',
    pre_delivery_summary: 'Résumé de pré-livraison',
    price_changes: 'Modifications de prix',
    old_price_change_description:
        'Votre concessionnaire souhaite que vous soyez informé de {{total}} changements de prix qui auront un impact sur votre total. Si vous avez des questions ou des préoccupations, contactez votre concessionnaire.',
    old_price_changes_description:
        'Votre concessionnaire souhaite que vous soyez informé des {{total}} changements de prix qui auront un impact sur votre total. Si vous avez des questions ou des préoccupations, contactez votre concessionnaire .',
    price_change_description:
        'Votre concessionnaire souhaite que vous soyez informé du changement {{total}} qui aura un impact sur votre total pour garantir le prix et la transparence à l’avance. Si vous avez des questions ou des préoccupations, contactez votre concessionnaire, {{dealerName}} au {{dealerPhoneNumber}}.',
    price_changes_description:
        'Votre concessionnaire souhaite que vous soyez informé du changement {{total}} qui aura un impact sur votre total pour garantir le prix et la transparence à l’avance. Si vous avez des questions ou des préoccupations, contactez votre concessionnaire, {{dealerName}} au {{dealerPhoneNumber}}.',
    prior_credit_lease_owed_on_trade: 'Solde de crédit ou de bail antérieur',
    print_pds_confirmation: 'Imprimez ou téléchargez le document accepté pour vos archives.',
    print: 'Imprimer',
    download: 'Téléchargement',
    rejected: 'rejeté',
    save_print: 'Enregistrez ou imprimez votre document',
    sub_heading:
        'Veuillez consulter l’estimation de prix fournie par votre concessionnaire. Votre concessionnaire peut vous aider à répondre à toutes vos questions.',
    surface_protection: 'Protection des surfaces',
    taxes_and_fees: 'Taxes et frais',
    term: 'Terme',
    thank_you: 'Merci {{name}} !',
    total_accessories: 'Total des accessoires',
    total_capitalized_cost_reductions: 'Réductions totales du coût capitalisé',
    total_credit_card_payment: 'Paiement total par carte de crédit',
    total_change: 'Changement total',
    total_net_change: 'Changement net total',
    total_change_popover_description:
        'La différence entre le prix estimé de votre commande et le prix actuel fourni par votre concessionnaire.',
    total_decreases: 'Réductions totales',
    total_down_payment: 'Acompte total',
    total_increases: 'Augments totaux',
    total_protection_plans: 'Plans de protection totaux',
    trade_in: 'Échange nette',
    vehicle_pricing_detail: 'Détail du prix du véhicule',
    vehicle_purchase_details: 'Détails d’achat de véhicule',
    vehicle_ordered_from: 'Véhicule commandé auprès de',
    view_changes: 'Afficher les modifications',
    view_disclosures: 'Afficher les divulgations',
    vin: 'NIV {{vin}}',
    yes_move_forward: 'Oui, avancer',
    yes: 'Oui',
    yr: 'an',
    accepted_pds: 'Vous avez accepté le résumé de pré-livraison',
    your_information: 'vos informations',
    dealer_selling_price: 'Prix de vente du concessionnaire',
    Processing: 'Traitement',
    no_refresh_message: 'Veuillez ne pas revenir en arrière ou actualiser.',
    accepted_file_types: '.jpeg, .jpg, .png, .pdf',
    accept_only_images: '.jpeg, .jpg, .png',
    sorry: 'Désolé!',
    error_heading: 'Nous rencontrons des problèmes avec notre système',
    error_message:
        'Nous ne sommes pas en mesure de traiter votre demande pour le moment. Veuillez réessayer plus tard.',
    delete_document_modal_title: 'Supprimer le document?',
    delete_document_modal_content:
        'Êtes-vous sûr de vouloir supprimer ce document? Vous devrez peut-être le remplacer.',
    no_go_back: 'Non, retour en arrière',
    yes_delete: 'Oui, Supprimer',
    mb: 'Mo',
    title: 'Veuillez télécharger les documents demandés par le concessionnaire',
    requested_by: 'Demandé par :',
    no_document_message: "Aucun document n'est demandé pour le moment.",
    sub_heading_one:
        'En téléchargeant, vous déclarez que toutes les informations sont à jour et exactes et vous avez le droit de les fournir.',
    sub_heading_two: 'Ces informations sont soumises à la politique de confidentialité de votre concessionnaire.',
    preparing_document: 'Préparation du document',
    applicant: 'Demandeur',
    coapplicant: 'Codemandeur',
    cobuyer: 'coacheteur',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    upload: 'Téléchargement',
    front: 'Avant',
    back: 'Retour',
    replace: 'Remplacer',
    undo: 'Annuler',
    crop: 'Récadrer',
    rotate: 'Tourner',
    done: 'Terminé',
    documents: 'documents',
    error_toaster_title: 'Erreur de téléchargement',
    unsupported_file_toaster_content:
        'Type de fichier non pris en charge. Vous ne pouvez télécharger que .jpeg, .jpg, .png ou .pdf.',
    image_supported_toaster_content:
        'Type de fichier non pris en charge. Vous ne pouvez télécharger que .jpeg, .jpg ou .png.',
    file_size_error: 'doc télécharger est trop volumineux',
    unsupported_file_type_error: 'type de fichier non pris en charge',
    harmful_javascript_error_code: 'Fichier JavaScript injecté',
    harmful_virus_error_code: 'Fichier infecté par un virus',
    harmful_javascript_error: 'fichier javascript potentiellement nuisible',
    harmful_virus_error: 'analyse virale de fichier potentiellement nuisible',
    harmful_toaster_title: 'Fichier potentiellement nuisible',
    harmful_toaster_content:
        'Le fichier que vous essayez de télécharger peut être nuisible. Veuillez télécharger un autre fichier.',
    accepted_files: 'Fichiers acceptés',
    back_to_doc: 'Retour au téléchargement du document',
    document_upload: 'Téléchargement de document',
    upload_driver_license: 'Télécharger le permis de conduire',
    documents_requested_by: 'Documents demandés par',
    max_file_size_and_types:
        'Taille maximale du fichier : 5 Mo | Taille de téléchargement totale max. : 10 Mo | Types de fichiers acceptés : .jpeg, .jpg, .png, .pdf',
    no_doc: 'Aucun document n’est demandé pour le moment',
    no_doc_sub: 'Vous serez averti par courriel lorsque votre concessionnaire demandera un document',
    edit_image: 'Modifier l’image',
    edit_or_replace: "Modifiez ou remplacez l'image et cliquez sur Terminé lorsque vous avez terminé la modification.",
    requested: 'Demandé',
    COMPLETED_DESC: 'Téléchargé',
    INPROGRESS_DESC: 'Téléchargement',
    ERROR_DESC: 'Erreur lors du téléchargement du document',
    FILESIZEERROR_DESC: 'La taille du fichier dépasse la limite de taille de ${MAX_MB} ${MB}',
    UPLOADED_DESC: 'Téléchargement réussi'
}

export const MESSAGES = getLanguage() === 'fr' ? MESSAGES_FR : MESSAGES_EN
